var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOuterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.997,
    height: 13.999,
    viewBox: "0 0 13.997 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13224",
    "data-name": "Group 13224",
    transform: "translate(-498.56 -462.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11170",
    "data-name": "Path 11170",
    d: "M512.057,469.868v6.5h-13v-13h6.5",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13224-2",
    "data-name": "Group 13224",
    transform: "translate(1.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11171",
    "data-name": "Path 11171",
    d: "M529.824,463.37h4.469v4.47",
    transform: "translate(-24.124)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_608",
    "data-name": "Line 608",
    x1: 11.023,
    y2: 11.5,
    transform: "translate(499.145 463.37)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterIcon);
export default __webpack_public_path__ + "static/media/outerIcon.29c0e4a23bcb37b51d919ae7b050d18e.svg";
export { ForwardRef as ReactComponent };